var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PerfilComponent } from './../perfil/perfil.component';
import { UserService } from 'src/app/services/user.service';
import { MatDialog, MatSnackBar } from 'node_modules/@angular/material';
import { TemplateRef } from '@angular/core';
import { FormService } from 'src/app/services/form.service';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { OptionService } from 'src/app/services/options.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Store } from '@ngrx/store';
import * as FormActions from '../../reducers/actions/forms.actions';
import { GLOBAL } from 'src/app/services/global';
import { AuxUrlInfTerComponent } from '../aux-url-inf-ter/aux-url-inf-ter.component';
import { MesonOnlineComponent } from '../meson-online/meson-online.component';
import { HomeComponent } from '../home/home.component';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { RegistroComponent } from '../home/registro/registro.component';
import { rutClean } from 'rut-helpers';
import { ToastrService } from 'ngx-toastr';
var InicioComponent = /** @class */ (function () {
    function InicioComponent(_optionService, dialog, _userService, snackBar, spinner, store, route, _router, claveUnicaService, toastr) {
        var _this = this;
        this._optionService = _optionService;
        this.dialog = dialog;
        this._userService = _userService;
        this.snackBar = snackBar;
        this.spinner = spinner;
        this.store = store;
        this.route = route;
        this._router = _router;
        this.claveUnicaService = claveUnicaService;
        this.toastr = toastr;
        this.matcher = new FormService();
        this.servicios = []; //listado de los servicios y sus tramites internos
        this.ifNotServicios = false; //flag, para saber si no hay ningun servicio activo y que muestre un mensaje al usuario
        this.footer = GLOBAL.footer;
        this.web = GLOBAL.web;
        this.webUrl = GLOBAL.webUrl;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.contActivos = 0;
        this.store.dispatch(new FormActions.FormUpdate('0', ''));
        localStorage.clear();
        sessionStorage.removeItem('borrador');
        this.form = new FormGroup({
            buscar: new FormControl('', Validators.required)
        });
        this.identity = this._userService.getIdentity();
        this.token = this._userService.getToken();
        if (this.route.snapshot.paramMap.get("token")) {
            this._userService.activeUser(this.route.snapshot.paramMap.get("token")).subscribe(function (response) {
                console.log('cuenta activada, response', response);
                if (response.active) {
                    alert("Cuenta activada");
                }
            }, function (error) {
                var e = JSON.parse(error._body);
            });
        }
        this.spinner.show();
        this._optionService.getServices().subscribe(function (response) {
            _this.servicios = response;
            if (_this.servicios.length < 0) {
                _this.ifNotServicios = true;
            }
            var flag = true;
            for (var i = 0; i < _this.servicios.length; i++) {
                if (_this.servicios[i].active)
                    flag = false;
            }
            _this.ifNotServicios = flag;
        }, function (error) {
            _this.ifNotServicios = true;
            console.log(error);
            console.log("Verifique la conexión a internet.");
        });
        this.spinner.show();
        this.route.queryParams.subscribe(function (params) {
            _this.tokenCU = params['tokenCU'] || null;
            if (_this.tokenCU) {
                sessionStorage.setItem('authToken', _this.tokenCU);
                _this.claveUnicaService.obtenerSesion(_this.tokenCU).subscribe(function (response) {
                    var sesion = response;
                    console.log("✅ Sesión encontrada");
                    _this.claveUnicaService.getInfoCiudadano(sesion.datos.code, sesion.datos.state).subscribe(function (response) {
                        if (response) {
                            swal({
                                type: 'success',
                                text: "Sesión iniciada con éxito",
                                showConfirmButton: true,
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false
                            });
                            var identityjson = {
                                "active": true,
                                "apellidoM": response.name.apellidos[1] ? response.name.apellidos[1] : "",
                                "apellidoP": response.name.apellidos[0] ? response.name.apellidos[0] : "",
                                "dv": response.RolUnico.DV ? response.RolUnico.DV : "",
                                "email": '-',
                                "nombres": response.name.nombres[0] && response.name.nombres[1] ? response.name.nombres[0] + " " + response.name.nombres[1] : "",
                                "rut": response.RolUnico.numero ? response.RolUnico.numero : "",
                                "telefono": '-'
                            };
                            sessionStorage.setItem('identity-domCloud', JSON.stringify(identityjson));
                            sessionStorage.setItem('token-domCloud', sesion.datos.code);
                            var route_1 = sesion.datos.route;
                            _this._router.navigate([route_1]);
                            _this.spinner.hide();
                        }
                        else {
                            _this.spinner.hide();
                        }
                    });
                }, function (error) {
                    _this.spinner.hide();
                    console.error('Error al encontrar la sesion:', error);
                    _this.snackBar.open("❌ Error al encontrar la sesion.", "Cerrar", {
                        duration: 3000,
                    });
                });
            }
            else if (!sessionStorage.getItem('identity-domCloud')) {
                _this.spinner.hide();
                console.warn("❌ No se encontró la sesion.");
                /*  this.snackBar.open("❌ No se encontró la sesion.", "Cerrar", {
                   duration: 3000,
                 }); */
            }
            _this.spinner.hide();
        });
    }
    InicioComponent.prototype.ngOnInit = function () {
    };
    InicioComponent.prototype.copyToClipboard = function (element) {
        var aux = document.createElement("input");
        aux.setAttribute("value", element);
        document.body.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        document.body.removeChild(aux);
        this.toastr.success('Listo!', 'Email copiado al portapapeles');
    };
    InicioComponent.prototype.sign = function (active, url) {
        console.log(active, url);
        if (active) {
            switch (url) {
                case 'expedientes':
                    this.dialog.open(this.sub_tramitesExp);
                    break;
                case 'certificados':
                    this.dialog.open(this.sub_tramitesCert);
                    break;
                case 'inspeccion':
                    this.dialog.open(this.sub_tramitesIns);
                    break;
                case 'informacion':
                    this.dialog.open(AuxUrlInfTerComponent, {
                        data: {
                            url: url
                        }
                    });
                    break;
                case 'atencion':
                    this.dialog.open(MesonOnlineComponent, {
                        data: {
                            url: url
                        }
                    });
                    break;
                case 'totem':
                    this.dialog.open(this.sub_tramitesTot);
                    break;
            }
        }
    };
    InicioComponent.prototype.subTramite = function (select) {
        console.log(select);
        this.dialog.closeAll();
        sessionStorage.setItem('selected-route', select);
        if (select == "pago-derecho") {
            window.open('https://ww16.e-com.cl/Pagos/PagosVariosv3/?id=70', '_blank');
        }
        else if (select == "seguimiento-expediente" || select == "seguimiento_certificados" || select == "certificados" || select == "validar-certificado" || select == "validar-documento" || select == "totem-busqueda-direccion") {
            this._router.navigate(["/" + select]);
        }
        else if (sessionStorage.getItem("identity-domCloud")) {
            this._router.navigate(["/" + select]);
        }
        else {
            this.dialog.open(HomeComponent, {
                data: {
                    url: select
                }
            });
        }
    };
    InicioComponent.prototype.ngDoCheck = function () {
        this.identity = this._userService.getIdentity();
        this.token = this._userService.getToken();
    };
    InicioComponent.prototype.handleImageError = function (card) {
        card.imageLoaded = false;
    };
    InicioComponent.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.store.dispatch(new FormActions.FormUpdate('0', ''));
                        sessionStorage.removeItem("identity-domCloud");
                        sessionStorage.removeItem("token-domCloud");
                        return [4 /*yield*/, this.claveUnicaService.logoutClaveUnica()];
                    case 1:
                        response = _a.sent();
                        console.log('Deslogeo exitoso:', response);
                        this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
                            duration: 3000,
                        });
                        this.back();
                        return [2 /*return*/];
                }
            });
        });
    };
    InicioComponent.prototype.openPerfil = function () {
        this.dialog.open(PerfilComponent);
    };
    InicioComponent.prototype.back = function () {
        this._router.navigate(['/inicio']);
    };
    InicioComponent.prototype.searchUser = function () {
        var _this = this;
        /* Buscar si existe en fm */
        var identityData = this._userService.getIdentity();
        var rut = identityData.rut + identityData.dv;
        this._userService.buscarUsuario(rutClean(rut)).subscribe(function (response) {
            if (response.message) {
                _this.spinner.hide();
                console.log(response);
            }
            if (response.register) {
                _this.spinner.hide();
                console.log(response);
                _this.dialog.open(RegistroComponent, {
                    id: "logindialog",
                    width: '50vw',
                    height: 'auto',
                    disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                });
            }
            if (response.update) {
                _this.spinner.hide();
                console.log(response);
                _this.dialog.open(RegistroComponent, {
                    id: "logindialog",
                    width: '50vw',
                    height: 'auto',
                    disableClose: true // Evita cerrar al hacer clic fuera (opcional)
                });
            }
        }, function (error) {
            var e = JSON.parse(error._body);
            _this.spinner.hide();
        });
    };
    return InicioComponent;
}());
export { InicioComponent };
